<template>
  <div class="sweden" role="main">
    <vue-headful title="Goodyear SightLine" description="Goodyear SightLine is Goodyear's new suite of tire intelligence solutions that help enable seamless, safe and reliable mobility for drivers, vehicles, operators and automakers."/>
    <section>
        <b-container class="form-header-logo-wrapper">
          <b-row class="justify-content-center">
            <b-col class="col-12">
              <img class="form-header-logo" src="../assets/images/goodyear-sightline-logo.png" alt="Goodyear logo" />
            </b-col>
          </b-row>
        </b-container>
    </section>
    <b-container class="p-0 header-image-wrapper">
        <div class="image-overlay">
          <h1 class="wf-head">Winter Grip</h1>
          <p>Experience tire intelligence in extreme conditions</p>
        </div>
        <picture>
            <source srcset="../assets/images/background/snow-tread-sm.png" media="(min-width: 576px, max-width: 767px)">
            <source srcset="../assets/images/background/snow-tread-md.png" media="(min-width: 768px, max-width: 991px)">
            <source srcset="../assets/images/background/snow-tread-lg.png" media="(min-width: 992px, max-width: 1199px)">
            <source srcset="../assets/images/background/snow-tread-xl.png" media="(min-width: 1200px)">
            <img class="form-header-image" src="../assets/images/background/snow-tread-xl.png" alt="Goodyear tire tread in snow" />
        </picture>
    </b-container>
    
    <SwedenSignUp/>
  </div>
</template>

<script>
import SwedenSignUp from './Shared/SwedenSignUp.vue'
export default {
  name: 'Sweden',
  components: {
    SwedenSignUp
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sweden {
  background-color: #F2F2F2;
  min-height: 100vh;
  color: #595959;
}

.header-image-wrapper {
    justify-content: center;
    position: relative;
    text-align: center;
}

.form-header-image {
    max-width: 100%;
    margin: auto;
    padding: 0px;
}

.image-overlay {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.53);
  text-align: left;
  padding: 0px 30px;
  z-index: 1;
}

.image-overlay h1 {
  color: #FFFFFF;
  font-weight: 500;
}

.image-overlay p {
  color: #FFFFFF;
  font-weight: 300;
}

/* Extra Small Screens */
@media (max-width: 576px) {
  .form-header-logo {
    width: 190px;
  }
  .form-header-logo-wrapper {
    padding: 20px;
  }
  .image-overlay h1 {
    font-size: 1.75rem;
    line-height: 2.25rem;
    font-weight: 500;
  }
  .image-overlay p {
    font-size: 0.75rem;
    line-height: 0rem;
    font-weight: 300;
  }
}

/* Small Screens */
@media (min-width: 576px) {
  .form-header-logo {
    width: 210px;
  }
  .form-header-logo-wrapper {
    padding: 30px;
  }
  .image-overlay h1 {
    font-size: 2.5rem;
    line-height: 2.5rem;
    font-weight: 500;
  }
  .image-overlay p {
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 300;
  }
}

/* Medium Screens */
@media (min-width: 768px) {
  .form-header-logo {
    width: 230px;
  }
  .form-header-logo-wrapper {
    padding: 30px 0px;
  }
  .image-overlay h1 {
    font-size: 2.8rem;
    line-height: 3.5rem;
    font-weight: 500;
  }
  .image-overlay p {
    font-size: 1.5rem;
    line-height: 1rem;
    font-weight: 300;
  }
}

/* Large Screens */
@media (min-width: 992px) {
  .form-header-logo {
    width: 260px;
  }
  .form-header-logo-wrapper {
    padding: 35px 0px;
  }
  .image-overlay h1 {
    font-size: 3.75rem;
    line-height: 4.5rem;
    font-weight: 500;
  }
  .image-overlay p {
    font-size: 1.6rem;
    line-height: 1.6rem;
    font-weight: 300;
  }
}

/* Extra Large Screens */
@media (min-width: 1200px) {
  .form-header-logo {
    width: 300px;
  }
  .form-header-logo-wrapper {
    padding: 40px 0px;
  }
  .image-overlay h1 {
    font-size: 4.375rem;
    line-height: 5rem;
    font-weight: 500;
  }
  .image-overlay p {
    font-size: 1.75rem;
    line-height: 2.25rem;
    font-weight: 300;
  }
}
</style>
